import React from 'react';
import {Link} from "react-router-dom";

function VehicleCard(props) {
    return <div className="col">
        <div id={`${props.vehicleName}-img-container`} className="card fleet-card h-100 special-img">
            <img id={`${props.vehicleName}-img`}
                 src={props.vehicleImageSrc}
                 className="card-img-top w-100 fleet-img"
                 alt={props.vehicleAlt}
                 onError={props.onError}
                 onMouseOver={props.onMouseOver}
                 onMouseOut={props.onMouseOut}
            />
            <div className="card-body">
                <div className="rating mt-3">
                    {props.renderStars}
                </div>
                <h5 className="card-title">{props.vehicleMakeAndModel}</h5>
            </div>
            <div className="card-footer">
                <Link
                    to={`/reservations?vehicle=${encodeURIComponent(props.vehicleMakeAndModel)}`}
                    className="btn btn-primary btn-block proceed-btn"
                >
                    Reserve Now
                </Link>
            </div>
        </div>
    </div>
}

export default VehicleCard;